import axios from 'axios';
import { message } from 'antd';
import JSONbig from 'json-bigint';
import {
    MOCK_SUCCESS,
    getSerialListData,
    voidSerial,
    getVoidRecordsData,
    getUnbindRecordsData,
    getResetRecordsData,
    resetSerialAuth,
    unbindSerialCpu,
    getImportRecordsData,
    getAlertListData,
    getPlatformListData,
    getModelListData,
    saveModelData,
    updateModelStatus,
    MOCK_MAC_RULE,
    MOCK_FACTORY_LIST,
    MOCK_ACCOUNT_LIST,
    getRoleListData,
    saveRoleData,
    deleteRoleData,
    loginUser,
    getOrderListData,
    shipmentDeclare,
    getShipmentRecordsData,
    returnDeclare,
    getReturnRecordsData,
    getNotifyConfigData,
    saveNotifyConfigData,
    testNotifyData
} from './mockData';

// 基础 API 地址
// export const BASE_URL = 'https://your-api.example.com';
export const BASE_URL = "";

// 创建 JSONbig 实例，配置为将大整数转换为字符串
const JSONbigString = JSONbig({ storeAsString: true });

// Mock Adapter Function
// TODO: 联调真实后端时，删除 axios.create 中的 adapter 行并设置 BASE_URL
const mockAdapter = (config) => {
    return new Promise((resolve) => {
        const { url } = config;

        // Simulate network delay
        setTimeout(() => {
            let responseData = { code: 0, message: 'success', data: {} };
            let username = 'admin';

            if (url.includes('/admin/login')) {
                if (config.data) {
                    try {
                        const parsedData = JSON.parse(config.data);
                        username = parsedData.username || 'admin';
                    } catch (e) {
                        console.warn('Failed to parse login data', e);
                    }
                }
                const perm = loginUser(username);
                responseData = {
                    code: 0,
                    message: '登录成功',
                    data: {
                        user_token: 'mock_token_123456',
                        user_info: {
                            username: username,
                            nick_name: username,
                            user_name: username,
                            role: perm.role,
                            is_admin: perm.is_admin
                        },
                        codes: perm.codes,
                        hidden_fields: perm.hidden_fields
                    }
                };
            } else if (url.includes('/admin/logout')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/admin/edit_pass')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/admin/edit_name')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/serial/import-records')) {
                responseData = getImportRecordsData();
            } else if (url.includes('/serial/import')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/serial/void-records')) {
                responseData = getVoidRecordsData();
            } else if (url.includes('/serial/unbind-records')) {
                responseData = getUnbindRecordsData(config.params);
            } else if (url.includes('/serial/reset-records')) {
                responseData = getResetRecordsData(config.params);
            } else if (url.includes('/serial/list')) {
                responseData = getSerialListData(config.params);
            } else if (url.includes('/serial/delete')) {
                let voidId = '';
                if (config.data) {
                    try { voidId = JSON.parse(config.data).id; } catch (e) { }
                }
                responseData = voidSerial(voidId);
            } else if (url.includes('/order/create')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/order/update')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/order/export')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/order/list')) {
                responseData = getOrderListData();
            } else if (url.includes('/serial/rebind')) {
                let rebindId = '';
                let action = '';
                if (config.data) {
                    try {
                        const parsed = JSON.parse(config.data);
                        rebindId = parsed.id;
                        action = parsed.action;
                    } catch (e) { }
                }
                responseData = action === 'unbind' ? unbindSerialCpu(rebindId) : resetSerialAuth(rebindId);
            } else if (url.includes('/serial/shipment-records')) {
                responseData = getShipmentRecordsData();
            } else if (url.includes('/serial/shipment')) {
                let shipmentData = {};
                if (config.data) {
                    try { shipmentData = JSON.parse(config.data); } catch (e) { }
                }
                responseData = shipmentDeclare(shipmentData);
            } else if (url.includes('/serial/return-records')) {
                responseData = getReturnRecordsData();
            } else if (url.includes('/serial/return')) {
                let returnData = {};
                if (config.data) {
                    try { returnData = JSON.parse(config.data); } catch (e) { }
                }
                responseData = returnDeclare(returnData);
            } else if (url.includes('/auth/alerts')) {
                responseData = getAlertListData();
            } else if (url.includes('/config/platform/save')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/config/platform/list')) {
                responseData = getPlatformListData();
            } else if (url.includes('/config/mac-rule/save')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/config/mac-rule')) {
                responseData = MOCK_MAC_RULE;
            } else if (url.includes('/config/model/status')) {
                let mPlatform = '';
                let mId = '';
                let mStatus = '';
                if (config.data) {
                    try {
                        const parsed = JSON.parse(config.data);
                        mPlatform = parsed.platform;
                        mId = parsed.id;
                        mStatus = parsed.status;
                    } catch (e) { }
                }
                responseData = updateModelStatus(mPlatform, mId, mStatus);
            } else if (url.includes('/config/model/save')) {
                let mPlatform = '';
                let mData = {};
                if (config.data) {
                    try {
                        const parsed = JSON.parse(config.data);
                        mPlatform = parsed.platform;
                        mData = parsed;
                    } catch (e) { }
                }
                responseData = saveModelData(mPlatform, mData);
            } else if (url.includes('/config/model/list')) {
                const mPlatform = (config.params && config.params.platform) || '';
                responseData = getModelListData(mPlatform);
            } else if (url.includes('/config/factory/save')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/config/factory/list')) {
                responseData = MOCK_FACTORY_LIST;
            } else if (url.includes('/config/notify/save')) {
                let notifyData = {};
                if (config.data) {
                    try { notifyData = JSON.parse(config.data); } catch (e) { }
                }
                responseData = saveNotifyConfigData(notifyData);
            } else if (url.includes('/config/notify/test')) {
                responseData = testNotifyData();
            } else if (url.includes('/config/notify')) {
                responseData = getNotifyConfigData();
            } else if (url.includes('/system/account/save')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/system/account/list')) {
                responseData = MOCK_ACCOUNT_LIST;
            } else if (url.includes('/system/role/delete')) {
                let roleId = '';
                if (config.data) {
                    try { roleId = JSON.parse(config.data).id; } catch (e) { }
                }
                responseData = deleteRoleData(roleId);
            } else if (url.includes('/system/role/save')) {
                let roleData = {};
                if (config.data) {
                    try { roleData = JSON.parse(config.data); } catch (e) { }
                }
                responseData = saveRoleData(roleData);
            } else if (url.includes('/system/role/list')) {
                responseData = getRoleListData();
            } else {
                // Default success for unknown endpoints to prevent crashing
                responseData = MOCK_SUCCESS;
            }

            // Return a valid axios response object
            resolve({
                data: responseData,
                status: 200,
                statusText: 'OK',
                headers: {},
                config,
                request: {}
            });
        }, 500);
    });
};

// 创建 axios 实例
const service = axios.create({
    baseURL: BASE_URL,
    timeout: 5000,
    adapter: mockAdapter, // Use the mock adapter
    transformResponse: [function (data) {
        // 使用 json-bigint 解析响应数据，保留大整数精度
        if (typeof data === 'string') {
            try {
                return JSONbigString.parse(data);
            } catch (e) {
                return data;
            }
        }
        return data;
    }]
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('user_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;

        if (res.code !== 0) {
            if (res.code === 1002) {
                message.error('登录失效，请重新登录');
                localStorage.removeItem('user_token');
                localStorage.removeItem('user_info');
                window.location.href = '/login';
            }
            return res;
        } else {
            return res;
        }
    },
    error => {
        console.log('err' + error);
        message.error(error.message);
        return Promise.reject(error);
    }
);

export default service;
